import { render } from "./Subject.vue?vue&type=template&id=041fda05&scoped=true"
import script from "./Subject.vue?vue&type=script&lang=js"
export * from "./Subject.vue?vue&type=script&lang=js"

import "./Subject.vue?vue&type=style&index=0&id=041fda05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041fda05"]])

export default __exports__